import { Pipe, PipeTransform } from '@angular/core';
import { OperationStatus } from "libraries/service/resources/model/search/IBooking";

@Pipe({
  name: 'severityStatusToIcon'
})
export class SeverityStatusToIconPipe implements PipeTransform {

  public transform(severity: string): OperationStatus {
    let icon: OperationStatus = OperationStatus.warning;
    if (severity.toUpperCase() === "ACTION_FAILED") {
      icon = OperationStatus.error;
    }
    if (severity.toUpperCase() === "CONTROL_ALERT" || severity.toUpperCase() === "CONTROL_FAILED") {
      icon = OperationStatus.warning;
    }
    return icon;
  }

}
